import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import MindsetsJsSDK, {LoadingAction, toastActions} from "mindsets-js-sdk";

import {downloadFile} from 'utils/index';
import {FILTER_1} from "../../../reducers/performance_reducers";

export default function ({printable}) {
    const dispatch = useDispatch();
    const params = useParams();

    const me = useSelector(state => state.me);
    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_filters = useSelector(state => state.dashboard_filters);

    if (printable) {
        return null;
    }

    if (!me || !me.is_dashboard_super_admin) {
        return null;
    }

    const dashboard_id = params.dashboard_id;
    if (!dashboard_id || dashboard_id.includes('demo')) {
        return null;
    }

    const onClick = async () => {
        const default_name = `Mindsets ${dashboard.title} Raw Data`;
        const input = window.prompt('File name:', default_name);
        if (input === null) {
            return;
        }
        const trimmed = input.trim();
        if (!trimmed) {
            return;
        }
        const title = trimmed.replace(/\.json$/i, '');

        const filters = dashboard_filters[FILTER_1];
        dispatch(LoadingAction(true, 'Preparing download…'));
        try {
            const response = await MindsetsJsSDK().API.get(
                `insights-dashboards/${dashboard_id}/data`,
                {current: 1, limit: 100000, ...filters}
            );
            const json = JSON.stringify(response.items, null, 2);
            downloadFile(dispatch, title, json, 'json', 'application/json');
        } catch (e) {
            dispatch(toastActions.ErrorMessageAction('We are sorry, there was a problem with downloading the file. Please try again later.'));
            console.error(e);
        } finally {
            dispatch(LoadingAction(false));
        }
    }

    return (
        <button
            className="btn btn-on-white"
            onClick={onClick}
        >
            {`Download raw data`}
        </button>
    );
}
